import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import MobileConnectionBase from "../pages/MobileConnectionBase";
import ChoiceTypeConnection from "../pages/ChoiceTypeConnection";

import PersonalDataHome from "../pages/PersonalData/PersonalDataHome";
import PersonalDataBusiness from "../pages/PersonalData/PersonalDataBusiness";

import ConfirmPhoneNumber from "../pages/ConfirmPhoneNumber";
import ConfirmPersonalData from "../pages/ConfirmPersonalData";

import ChoiceContract from "../pages/ChoiceContract";
import ChoiceServiceListHome from "../pages/ChoiceServices/ChoiceServiceListHome";

import ChoiceServiceListBusiness from "../pages/ChoiceServices/ChoiceServiceListBusiness";
import ConfirmInternetCable from "../pages/ConfirmInternetCable/ConfirmInternetCable";

import Payment from "../pages/Payment";
import Documents from "../pages/Documents";

import ChoiceDateTimeDeparture from "../pages/ChoiceDateTimeDeparture/ChoiceDateTimeDeparture";
import FinishHome from "../pages/Finish/FinishHome";

import FinishBusiness from "../pages/Finish/FinishBusiness";

const URL_MOBILE_CONNECTION = "/iwantufanet";

export const APP_ROUTES = {
  ROOT_ROUTE: "/",

  MOBILE_CONNECTION: {
    ROOT_ROUTE: URL_MOBILE_CONNECTION,
    START_ROUTE: `${URL_MOBILE_CONNECTION}/start`,
    PERSONAL_DATA_ROUTE: `${URL_MOBILE_CONNECTION}/personal-data`,
    PERSONAL_DATA_BUSINESS_ROUTE: `${URL_MOBILE_CONNECTION}/personal-data-business`,
    CONFIRM_PHONE_NUMBER_ROUTE: `${URL_MOBILE_CONNECTION}/confirm-phone-number`,
    CONFIRM_PERSONAL_DATA_ROUTE: `${URL_MOBILE_CONNECTION}/confirm-personal-data`,
    CHOICE_CONTRACT_ROUTE: `${URL_MOBILE_CONNECTION}/choice-contract`,
    CHOICE_SERVICES_ROUTE: `${URL_MOBILE_CONNECTION}/choice-services`,
    CHOICE_SERVICES_BUSINESS_ROUTE: `${URL_MOBILE_CONNECTION}/choice-services-business`,
    CONFIRM_INTERNET_CABLE: `${URL_MOBILE_CONNECTION}/confirm-internet-cable`,
    PAYMENT_ROUTE: `${URL_MOBILE_CONNECTION}/payment`,
    DOCUMENTS_ROUTE: `${URL_MOBILE_CONNECTION}/documents`,
    CHOICE_DEPARTURE_TIME: `${URL_MOBILE_CONNECTION}/choice-departure-time`,
    FINISH_ROUTE: `${URL_MOBILE_CONNECTION}/finish`,
    FINISH_BUSINESS_ROUTE: `${URL_MOBILE_CONNECTION}/finish-business`,
  },
};

export const routeList = createBrowserRouter([
  {
    path: APP_ROUTES.MOBILE_CONNECTION.ROOT_ROUTE,
    element: <MobileConnectionBase />,
    children: [
      {
        index: true,
        element: <Navigate to={APP_ROUTES.MOBILE_CONNECTION.START_ROUTE} />,
      },
      {
        path: `${APP_ROUTES.MOBILE_CONNECTION.START_ROUTE}/:slug?`,
        element: <ChoiceTypeConnection />,
      },
      {
        path: `${APP_ROUTES.MOBILE_CONNECTION.START_ROUTE}/tinkoff`,
        element: <PersonalDataHome />,
      },
      {
        path: `${APP_ROUTES.MOBILE_CONNECTION.START_ROUTE}/alpha`,
        element: <PersonalDataHome />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.PERSONAL_DATA_ROUTE,
        element: <PersonalDataHome />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.PERSONAL_DATA_BUSINESS_ROUTE,
        element: <PersonalDataBusiness />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.CONFIRM_PHONE_NUMBER_ROUTE,
        element: <ConfirmPhoneNumber />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.CONFIRM_PERSONAL_DATA_ROUTE,
        element: <ConfirmPersonalData />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.CHOICE_CONTRACT_ROUTE,
        element: <ChoiceContract />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.CHOICE_SERVICES_ROUTE,
        element: <ChoiceServiceListHome />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.CHOICE_SERVICES_BUSINESS_ROUTE,
        element: <ChoiceServiceListBusiness />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.CONFIRM_INTERNET_CABLE,
        element: <ConfirmInternetCable />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.PAYMENT_ROUTE,
        element: <Payment />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.DOCUMENTS_ROUTE,
        element: <Documents />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.CHOICE_DEPARTURE_TIME,
        element: <ChoiceDateTimeDeparture />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.FINISH_ROUTE,
        element: <FinishHome />,
      },
      {
        path: APP_ROUTES.MOBILE_CONNECTION.FINISH_BUSINESS_ROUTE,
        element: <FinishBusiness />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to={APP_ROUTES.MOBILE_CONNECTION.START_ROUTE} />,
  },
]);
